module.exports = __webpack_public_path__ + "img/symbol_0.e153ef06.png";